import { modelOptions, post, prop } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "LoggerFlags" as const;

type FieldsWithDefaults = "wrongTime" | "error" | "lowBat" | "missedManyUplinks" | "badAPIKey" | "badURL" | "longSleep";

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerFlags>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerFlags extends SchemaBase<LoggerFlags, FieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Boolean, required: false })
    public willRespond?: boolean;

    @prop({ type: () => Boolean, required: true, default: false })
    public wrongTime: boolean = false;

    @prop({ type: () => Boolean, required: true, default: false })
    public error: boolean = false;

    @prop({ type: () => Boolean, required: true, default: false })
    public lowBat: boolean = false;

    @prop({ type: () => Boolean, required: true, default: false })
    public missedManyUplinks: boolean = false;

    @prop({ type: () => Boolean, required: true, default: false })
    public badAPIKey: boolean = false;

    @prop({ type: () => Boolean, required: true, default: false })
    public badURL: boolean = false;

    @prop({ type: () => Boolean, required: true, default: false })
    public longSleep: boolean = false;

    static getters = {} as const satisfies Record<string, (self: LoggerFlags) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<LoggerFlags, FieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}
